var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisPlanning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.75V3.4C10 2.55992 10 2.13988 9.8365 1.81902C9.6927 1.53677 9.46325 1.3073 9.181 1.16349C8.8601 1 8.4401 1 7.6 1H4.4C3.55992 1 3.13988 1 2.81902 1.16349C2.53677 1.3073 2.3073 1.53677 2.16349 1.81902C2 2.13988 2 2.55992 2 3.4V8.6C2 9.4401 2 9.8601 2.16349 10.181C2.3073 10.4632 2.53677 10.6927 2.81902 10.8365C3.13988 11 3.55992 11 4.4 11H7M7 5.5H4M5 7.5H4M8 3.5H4M8.25 7.5011C8.3381 7.2507 8.512 7.0395 8.74085 6.905C8.96975 6.77045 9.23885 6.7213 9.5005 6.7662C9.76215 6.81105 9.9995 6.9471 10.1705 7.1502C10.3415 7.3533 10.435 7.61035 10.4346 7.87585C10.4346 8.6253 9.31045 9 9.31045 9M9.32495 10.5H9.32995",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisPlanning);
export default __webpack_public_path__ + "static/media/dis_planning.0f268c88d2ec83fb8b17af4c7ec440f2.svg";
export { ForwardRef as ReactComponent };